import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus } from "lucide-react";
import Logo from "../assets/logos/logo.png";
import { useAuth } from "../context/AuthContext";
import { getReferrerMe, registerReferrer } from "../services/referrerService";

const ReferrerOnboarding = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [registering, setRegistering] = useState(false);

  // If the user navigates back here after already registering (e.g. via
  // browser back button), just skip straight to the dashboard instead of
  // asking again.
  useEffect(() => {
    getReferrerMe().then((referrer) => {
      if (referrer) {
        navigate("/", { replace: true });
      } else {
        setChecking(false);
      }
    });
  }, [navigate]);

  const handleContinue = async () => {
    setRegistering(true);
    try {
      await registerReferrer();
      navigate("/", { replace: true });
    } finally {
      setRegistering(false);
    }
  };

  const handleDecline = () => {
    logout();
    navigate("/login", { replace: true });
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-bg-base flex items-center justify-center">
        <p className="text-text-muted text-sm">Loading…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg-base flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full opacity-10"
          style={{
            background: "radial-gradient(ellipse, #139679 0%, transparent 70%)",
          }}
        />
      </div>

      <div className="w-full max-w-sm z-10">
        <div className="flex flex-col items-center mb-8">
          <img src={Logo} alt="Ingroove" className="h-10 mb-3" />
        </div>

        <div className="bg-bg-surface border border-border rounded-2xl p-8 shadow-card text-center">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-5">
            <UserPlus size={22} className="text-primary" />
          </div>

          <h2 className="text-text-primary text-lg font-semibold mb-2">
            You're not a referrer yet
          </h2>
          <p className="text-text-muted text-sm mb-7">
            You'll get a unique referral link and can start earning a share
            of Ingroove's commission whenever a hub you refer runs their
            first paid event.
          </p>

          <button
            onClick={handleContinue}
            disabled={registering}
            className="w-full ingroove-gradient-bg text-white font-semibold text-sm py-2.5 rounded-xl hover:opacity-90 transition disabled:opacity-50 shadow-glow mb-3"
          >
            {registering ? "Setting up…" : "Continue as a referrer"}
          </button>

          <button
            onClick={handleDecline}
            disabled={registering}
            className="w-full text-text-muted hover:text-text-secondary text-sm py-2 transition disabled:opacity-50"
          >
            No thanks, log me out
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferrerOnboarding;
